import "mapbox-gl/dist/mapbox-gl.css"
import "polyfill"
import "react-quill-new/dist/quill.snow.css"
import "resources/css/main.css"
import "./start.app"

export default "ok"
